import { DataProvider, Identifier } from "react-admin";
import { ErrorMessage } from "../../common/components/utils/error";
import { createWorflowStages } from "../stage/actions";
import { checkWorkflow, readModel } from "./reader";

/**
 * Validation des stages & création des stages
 * @param dataProvider 
 * @param model 
 * @param workflowId 
 * @returns 
 */
export const workflowValidate = (dataProvider: DataProvider, model: string, workflowId: Identifier) => async (): Promise<ErrorMessage[]> => {
    const js = readModel(model);
    const errors = await checkWorkflow(js);
    // If valid, we create the workflow stages
    if (errors.length === 0) {
        await createWorflowStages(dataProvider, js, workflowId);
    }
    return errors;
};

export const getCols = (width: number): number => {
    return (width) ? Math.round(width / 490) : 3;
};